export enum StoreType {
	Cloud = 'SERVER_TYPE_CLOUD',
	StoreFront = 'AM_SERVER_TYPE_STOREFRONT',
	AdvancedGateway = 'AM_SERVER_TYPE_GATEWAY_ADVANCED',
	BasicGateway = 'AM_SERVER_TYPE_GATEWAY_BASIC',
	Gateway = 'AM_SERVER_TYPE_GATEWAY',
	Unknown = 'AM_SERVER_TYPE_UNKNOWN',
}

export enum NetworkLocation {
	Deciding = 'NetworkLocationDeciding',
	Inside = 'NetworkLocationLAN',
	Outside = 'NetworkLocationOutside',
	None = 'NetworkLocationNone',
	Vpn = 'NetworkLocationVPN',
	Hotspot = 'NetworkLocationHotspot',
}

export interface OIDCConfiguration {
	readonly oidc_discovery_endpoint: string;
	readonly oidc_clients: {
		[key: string]: Array<{ name: string; id: string }>;
	};
}

export interface SingleStoreConfiguration {
	readonly tokenServiceURL: string;
	readonly oidcConfiguration: OIDCConfiguration | null;
	readonly authDomain: string;
	readonly acrValues?: string | null;
	readonly promptLoginEnabled?: boolean;
	readonly storeType?: StoreType;
	readonly defaultGatewayLocation?: string;
	readonly networkLocation?: NetworkLocation;
	readonly storeName?: string;
	readonly beacon?: string;
	readonly secondaryTokenWhitelistUrls?: string[] | null;
}

export interface StoreConfiguration {
	[key: string]: SingleStoreConfiguration;
}

export enum GACSDiscoveryRegion {
	DEFAULT = 'default',
	USGOV = 'usgov'
}
